import type {
  AlloyLegacyThemeDesignTokens,
  ContentLoaderDesignTokens,
  SkeletonDesignTokens,
} from '../types';
import type { Weave3SkeletonInput } from '../types/weave3Types';
import { WeaveTheme } from '../types/weaveTypes';

type WeaveTokens = NonNullable<WeaveTheme['tokens']>;

export const getSkeletonTokensAlloy = (
  theme: AlloyLegacyThemeDesignTokens,
): SkeletonDesignTokens => ({
  'background-color': theme.tokens.colors.skeleton.shimmer.one.value,
  highlight: {
    'background-color': theme.tokens.colors.skeleton.shimmer.two.value,
  },
});

/** Weave 2 ships shape radii and `highlight.width` too; passed through so no consumer loses keys. */
export const getSkeletonTokensWeave = (
  tokens: WeaveTokens,
): SkeletonDesignTokens => {
  const skeleton = tokens?.component?.skeleton;

  return {
    ...skeleton,
    'background-color': skeleton?.['background-color'],
    highlight: {
      ...skeleton?.highlight,
      'background-color': skeleton?.highlight?.['background-color'],
    },
  };
};

export const getSkeletonTokensWeave3 = (
  skeleton?: Weave3SkeletonInput,
): SkeletonDesignTokens => ({
  'background-color': skeleton?.['background-color'],
  highlight: {
    'background-color': skeleton?.highlight?.['background-color'],
  },
});

/** Deprecated Alloy-named view of `skeleton`, still the branch `ContentLoader` reads. */
const toContentLoader = (
  skeleton: SkeletonDesignTokens,
): ContentLoaderDesignTokens => ({
  'background-color': skeleton['background-color'],
  'foreground-color': skeleton.highlight?.['background-color'],
});

export const getContentLoaderTokensAlloy = (
  theme: AlloyLegacyThemeDesignTokens,
): ContentLoaderDesignTokens => toContentLoader(getSkeletonTokensAlloy(theme));

export const getContentLoaderTokensWeave = (
  tokens: WeaveTokens,
): ContentLoaderDesignTokens => toContentLoader(getSkeletonTokensWeave(tokens));

export const getContentLoaderTokensWeave3 = (
  skeleton?: Weave3SkeletonInput,
): ContentLoaderDesignTokens =>
  toContentLoader(getSkeletonTokensWeave3(skeleton));
